import React from 'react';
import { observer } from 'mobx-react-lite';
import { useZywaveRedirectPageStore } from 'store/pages/quote/zywave-redirect-page/pageStore';
import { CardQuantityStyled, CardTitleStyled, GeneralStatisticsWrapperStyled, StatisticsCardStyled } from './styles';

export const GeneralStatistics: React.FC = observer(() => {
  const { quotingStatistics } = useZywaveRedirectPageStore();

  if (!quotingStatistics) {
    return null;
  }

  const { eesOnly, eesWithDeps, depsTotal } = quotingStatistics;

  return (
    <GeneralStatisticsWrapperStyled>
      <StatisticsCardStyled>
        <CardQuantityStyled>{eesOnly}</CardQuantityStyled>
        <CardTitleStyled>Employees (no dependents)</CardTitleStyled>
      </StatisticsCardStyled>
      <StatisticsCardStyled>
        <CardQuantityStyled>{eesWithDeps}</CardQuantityStyled>
        <CardTitleStyled>Employees with dependents</CardTitleStyled>
      </StatisticsCardStyled>
      <StatisticsCardStyled>
        <CardQuantityStyled>{depsTotal}</CardQuantityStyled>
        <CardTitleStyled>Dependents (total)</CardTitleStyled>
      </StatisticsCardStyled>
    </GeneralStatisticsWrapperStyled>
  );
});
